import { CheckCircleOutline, HighlightOffRounded } from '@material-ui/icons';
import React, { memo } from 'react';
import { OrgUserStatus } from 'src/types';
import PendingIcon from '../Icons/PendingIcon';

type Props = {
  status: OrgUserStatus;
};

export const StatusIcon: React.FC<Props> = ({ status }) => {
  if (status === OrgUserStatus.Active) {
    return <CheckCircleOutline data-testid="active-icon" />;
  }
  if (status === OrgUserStatus.Inactive) {
    return <HighlightOffRounded data-testid="inactive-icon" />;
  }
  return <PendingIcon data-testid="pending-icon" />;
};

export default memo(StatusIcon);
